import { PropsWithChildren, useEffect } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router";
import { useTranslation } from "react-i18next";
import useLangs from "@/languages/hooks/useLangs";

interface NavLanguageProvider extends PropsWithChildren {
	path?: string;
}

// This provider checks the url and the current cookies for authentication
export const NavLanguageProvider = ({
	path = "",
  children
}: NavLanguageProvider) => {
	const params = useParams();
	const [searchParams, _setSearchParams] = useSearchParams();
  const location = useLocation();
	const { t } = useTranslation();
  const { currentLang } = useLangs();
  const navigate = useNavigate();

  const getTranslatedPath = (withSearchParams?: boolean) => {
    return t(path.replace("{{", ":").replace("}}", ""), params) + 
      (withSearchParams ? ("?" + searchParams) : "")
  }

  const isLocationCorrect = () => {
    return path ? (getTranslatedPath() == location.pathname) : true
  }
  
  useEffect(() => {
    if (!isLocationCorrect()) {
      navigate(getTranslatedPath(true), {replace: true});
    }
  }, [path, currentLang])

  return children;
}
